import { api } from '@api'

import { GetSuppliersResponse, Supplier, SupplierFilters } from '../../types'

interface GetSuppliersByMgmtResponse {
  suppliers: Supplier[]
}

interface Params {
  filters: SupplierFilters | undefined
}

const getSuppliers = async () => {
  const response = await api.get<GetSuppliersResponse>('/suppliers')

  return response.data.suppliers
}
const getSuppliersByMgmt = async (params: Params) => {
  const { filters } = params
  const response = await api.get<GetSuppliersByMgmtResponse>('/suppliers', {
    params: {
      ...filters,
    },
  })
  return response.data.suppliers
}

export const SuppliersApi = { getSuppliers, getSuppliersByMgmt }
